import type { CityConfig } from "../city-template/types";

export const durangoConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Colorado Vital Records (Birth, Death)", href: "https://cdphe.colorado.gov/vital-records", description: "Official Colorado Department of Public Health vital records office in Denver" },
    { label: "La Plata County Clerk — Marriage &amp; Vital Records", href: "https://www.co.laplata.co.us/", description: "La Plata County Clerk — marriage licenses and local vital records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Colorado CDPHE for online vital record orders" },
  ],
  city: "Durango",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "durango",
  route: "/durango",
  title: "Emergency Passport Durango, CO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Durango, Colorado — as fast as 24 hours. Same-day courier processing for Durango, Bayfield, Ignacio, and all La Plata County travelers. A+ BBB rated, registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Durango, CO",
  heroSubtitle: "International adventure trip to Patagonia and your passport just expired? Study abroad program at Fort Lewis College starting in days? We help Durango residents — from downtown Animas River valley dwellers to La Plata County ranchers to Four Corners outdoor enthusiasts — get their passports fast. As a registered State Dept. courier, we offer rates typically 30–100% lower than other courier resellers. As fast as 24 hours. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Durango%20Colorado%20scenic%20view%20with%20the%20historic%20Durango%20and%20Silverton%20Narrow%20Gauge%20Railroad%20steam%20train%20winding%20through%20the%20San%20Juan%20Mountains%20along%20the%20Animas%20River%20canyon%2C%20the%20charming%20historic%20downtown%20Durango%20with%20Victorian%20era%20buildings%20and%20the%20Strater%20Hotel%2C%20lush%20green%20mountain%20backdrop%20with%20alpine%20peaks%2C%20golden%20afternoon%20sunlight%2C%20professional%20landscape%20photography%20capturing%20the%20Old%20West%20meets%20mountain%20town%20atmosphere%2C%20no%20visible%20text%20or%20people%2C%20cinematic%20wide%20angle%20view&width=1800&height=700&seq=durango-hero-001&orientation=landscape",
  heroImageAlt: "Durango Colorado with Narrow Gauge Railroad, Animas River, and historic downtown",
  geoPosition: "37.2753;-107.8801",
  geoPlacename: "Durango, Colorado",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Colorado Passport Agency",
    address: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
    distance: "Approximately 340 miles northeast via US-285 — about 6 hours",
  },
  nearbyCitiesZips: [
    { name: "Durango", zips: "81301, 81303" },
    { name: "Bayfield", zips: "81122" },
    { name: "Ignacio", zips: "81137" },
    { name: "Hesperus", zips: "81326" },
    { name: "Hermosa", zips: "81301" },
    { name: "Silverton", zips: "81433" },
    { name: "Cortez", zips: "81321" },
    { name: "Mancos", zips: "81328" },
    { name: "Dolores", zips: "81323" },
    { name: "Pagosa Springs", zips: "81147" },
    { name: "Aztec, NM", zips: "87410" },
    { name: "Farmington, NM", zips: "87401, 87402" },
    { name: "Bloomfield, NM", zips: "87413" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier for urgent Four Corners departures — skip the 6-hour Denver drive" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved — essential for southwest Colorado's remote location" },
    { icon: "ri-flight-takeoff-line", title: "DRO Airport Service", desc: "Durango-La Plata County Airport with connections to major hubs" },
    { icon: "ri-mail-send-line", title: "Overnight Shipping", desc: "Prepaid labels from any UPS or FedEx in La Plata County" },
  ],
  internalLinks: [
    { name: "Expedited passport in Denver, CO", route: "/denver" },
    { name: "Emergency passport help in Colorado Springs", route: "/colorado-springs" },
    { name: "Fast passport renewal in Farmington, NM area", route: "/durango" },
    { name: "Urgent passport services for Bayfield and Ignacio", route: "/durango" },
    { name: "Colorado passport services overview", route: "/colorado" },
    { name: "Passport courier services for all of La Plata County", route: "/durango" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Durango remotely via secure registered courier. Our couriers hand-deliver your documents directly to U.S. Department of State processing facilities. Durango's Four Corners location — 340 miles from the Colorado Passport Agency — makes our courier service essential. Skip the 12-hour roundtrip drive and let our couriers handle everything.",
  fpcOfficeAddress: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
  fpcOfficeDistance: "Serving all of La Plata County, the San Juan Basin, and the Four Corners region",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Durango and La Plata County. From the historic downtown along Main Avenue to the Animas River Valley, from the Fort Lewis College campus to the residential neighborhoods on the mesa — we serve every corner of Durango and the surrounding Four Corners communities.",
  nearbyCitiesIntro: "We serve Durango and all nearby communities including Bayfield, Ignacio, Hesperus, Hermosa, Silverton, Cortez, Mancos, and Dolores. We also serve Pagosa Springs, Farmington (NM), Aztec (NM), and the entire Four Corners region.",
  howItWorksIntro: "Most Durango travelers complete everything online and ship documents overnight. Our couriers handle all State Department delivery — saving you the 680-mile roundtrip drive to Denver through the San Juan Mountains.",
  mistakesIntro: "Durango is the gateway to the Four Corners with a university, tourism, and energy industries creating significant international travel demand. Here are the most common passport mistakes we see from Durango-area travelers.",
  testimonialsIntro: "Durango travelers — from Fort Lewis College students to outdoor adventure guides to Four Corners professionals — trust us when departure is imminent.",
  faqIntro: "Have questions about expedited passports in Durango, CO? Here are the most common ones we hear from Four Corners travelers.",
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Denver drive — ship from Durango", "Ideal for adventure travel and FLC study abroad", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service from remote SW Colorado", "Good for planned travel from DRO", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Denver (6 hours each way)", "Wolf Creek Pass & South Park — weather dependent"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Durango travelers with immediate departure — as fast as 24 hours. Our couriers handle the 340-mile Denver trip so you don't waste 12+ hours driving.",
      bullets: ["24–48 hour turnaround available", "DRO flight connections to Denver, Dallas, Phoenix", "FLC study abroad and adventure travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Durango adults with a passport issued within the last 15 years. Skip the post office entirely.",
      bullets: ["No clerk visit required for most renewals", "Courier or mail-in options", "Returned to your La Plata County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Durango residents and La Plata County families — including FLC students and Southern Ute tribal members.",
      bullets: ["Acceptance facility scheduling in Durango", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Durango residents — whether lost on the river, trail, or before an international adventure.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Durango and La Plata County families heading abroad with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Durango and La Plata County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Durango CO", description: "Urgent passport processing for Durango Colorado travelers with immediate departure needs from DRO or connecting hubs." },
    { name: "Expedited Passport Renewal Durango CO", description: "Fast passport renewal for Durango Colorado residents with a previously-issued passport." },
    { name: "First-Time Passport Durango CO", description: "New passport application services for Durango Colorado residents applying for their first passport." },
    { name: "Child Passport Durango CO", description: "Minor passport services for Durango Colorado families with children under 16." },
  ],
  testimonials: [
    {
      name: "Rachel K.",
      location: "Durango, CO — Downtown",
      rating: 5,
      text: "Study abroad program through Fort Lewis College starting in 5 days and my passport was expired. Fast Passport Center got my renewal in 2 days. Shipped from the UPS Store on Main Avenue and I made my flight to Spain.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Marcus J.",
      location: "Bayfield, CO",
      rating: 5,
      text: "River guiding trip to Chile with 10 days notice. Fast Passport Center had everything sorted in 3 days. No way I was driving 12 hours roundtrip to Denver. The courier service is a game-changer for southwest Colorado.",
      service: "Emergency Passport",
    },
    {
      name: "Sarah T.",
      location: "Durango, CO — Animas Valley",
      rating: 5,
      text: "Family trip to Costa Rica — four passports including two first-time for the kids. Done in 5 days. Living in the Four Corners, the courier service is the only practical option for fast passports.",
      service: "Family Passport Bundle",
    },
    {
      name: "John W.",
      location: "Cortez, CO",
      rating: 5,
      text: "Archaeology conference in Peru with one week notice. Fast Passport Center processed my emergency passport in 3 days. Flying from DRO through Denver was flawless.",
      service: "Emergency Passport",
    },
  ],
  facilities: [
    {
      id: "dur-1",
      name: "Durango Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "222 W 8th St",
      city: "Durango",
      state: "CO",
      zip: "81301",
      phone: "(970) 247-3950",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Durango, near Main Avenue",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Durango acceptance facility. Appointments required — book 2–3 weeks in advance during summer tourism and FLC semester starts.",
      icon: "ri-mail-line",
    },
    {
      id: "dur-2",
      name: "Bayfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "145 E Mill St",
      city: "Bayfield",
      state: "CO",
      zip: "81122",
      phone: "(970) 884-9350",
      hours: "Mon–Fri: 9:00 AM – 3:30 PM",
      distance: "Bayfield, approximately 20 miles east of Durango",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Bayfield and eastern La Plata County. Limited hours — call ahead. Convenient for Pine River Valley residents.",
      icon: "ri-mail-line",
    },
    {
      id: "dur-3",
      name: "Ignacio Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1001 Williams St",
      city: "Ignacio",
      state: "CO",
      zip: "81137",
      phone: "(970) 563-4588",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "Ignacio, approximately 25 miles southeast of Durango",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Ignacio, Southern Ute Reservation, and southern La Plata County. Very limited hours — always call ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "dur-4",
      name: "Cortez Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "35 S Beech St",
      city: "Cortez",
      state: "CO",
      zip: "81321",
      phone: "(970) 565-7581",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Cortez, approximately 45 miles west of Durango",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Cortez and Montezuma County. Good alternative for southwest Colorado residents. Near Mesa Verde National Park.",
      icon: "ri-mail-line",
    },
    {
      id: "dur-5",
      name: "La Plata County Clerk — Durango",
      type: "County Clerk Passport Acceptance",
      address: "98 Everett St, Suite C",
      city: "Durango",
      state: "CO",
      zip: "81303",
      phone: "(970) 382-6280",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Bodo Park area, approximately 2 miles south of downtown Durango",
      website: "https://www.co.laplata.co.us/",
      websiteLabel: "La Plata County Clerk",
      notes: "County clerk passport acceptance with extended hours. Full-service facility for all La Plata County residents. Ample parking available.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 340 mi to Denver, 6hr each way", fpc: "No — ship from Durango" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Wolf Creek Pass Winter", agency: "Treacherous winter mountain driving", fpc: "No driving needed — courier handles it" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Too Long — Four Corners Mail Is Slow",
      description: "Standard mail from Durango to passport processing centers on the East Coast takes significantly longer than from Front Range cities. Routine processing can take 10–14 weeks. Always use expedited courier service from southwest Colorado.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Photos from local drugstores sometimes don't meet strict State Department standards. Must be exactly 2×2 inches on white background — no outdoor or mountain scenery backdrops.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities During Peak Season",
      description: "Durango acceptance facilities get booked during summer tourism (June–August) and FLC semester starts (August and January). Book 3 weeks ahead during peak periods.",
    },
    {
      icon: "ri-road-map-line",
      title: "Attempting the Denver Drive",
      description: "Driving 340 miles to the Colorado Passport Agency is a 12+ hour roundtrip over Wolf Creek Pass and through the San Luis Valley. Winter conditions make this extremely dangerous. Use courier service instead.",
    },
    {
      icon: "ri-flight-takeoff-line",
      title: "Not Planning DRO Connections",
      description: "DRO has limited flights to Denver, Dallas, and Phoenix. All international travel requires a connection. Factor connection time and airport transfers into your passport planning.",
    },
    {
      icon: "ri-global-line",
      title: "Assuming New Mexico Agencies Are Closer",
      description: "While Albuquerque is geographically closer than Denver, U.S. passport agencies serve by state jurisdiction. Colorado residents must use the Colorado Passport Agency. Our courier service bridges this gap.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in La Plata County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop at any UPS or FedEx in Durango, Bayfield, or Cortez." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for Four Corners paperwork." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to State Department facilities — you skip the 680-mile Denver roundtrip." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Durango address — trackable every step." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Durango, CO?", a: "Fast Passport Center offers emergency passport processing in Durango, Colorado in as little as 24–48 hours. Our registered couriers hand-deliver your documents to U.S. Department of State facilities — no need to make the 340-mile, 6-hour drive over Wolf Creek Pass to the Colorado Passport Agency." },
    { q: "Does Durango have its own passport agency?", a: "No — Durango does not have a regional passport agency. The nearest is the Colorado Passport Agency (approximately 340 miles northeast via US-285 — a 6-hour drive). Fast Passport Center's courier service is the only practical option for fast passport processing from southwest Colorado." },
    { q: "What airport does Durango use for international flights?", a: "Durango-La Plata County Airport (DRO) offers daily flights to Denver (DEN), Dallas (DFW), and seasonal flights to Phoenix (PHX). All international travel requires a connection through a major hub. Always verify passport validity for your full itinerary beyond DRO." },
    { q: "Can I use the Albuquerque passport agency instead of Denver?", a: "U.S. passport agencies serve by state jurisdiction. Colorado residents, including Durango travelers, must use the Colorado Passport Agency for emergency appointments. Fast Passport Center's courier service works regardless of which agency processes your application." },
    { q: "Can you help with passports for Fort Lewis College students?", a: "Absolutely. Fast Passport Center serves all FLC students and faculty traveling internationally for study abroad, research, conferences, or personal travel. We understand academic schedules and can help with tight deadlines around semester starts and breaks." },
    { q: "What about travelers from Bayfield, Ignacio, or Pagosa Springs?", a: "Yes. Fast Passport Center serves all of La Plata County including Bayfield, Ignacio, Hesperus, and Hermosa. We also serve Archuleta County (Pagosa Springs), Montezuma County (Cortez, Mancos, Dolores), and San Juan County (Silverton). We even serve Farmington and Aztec, NM across the state line." },
    { q: "How much does an expedited passport cost in Durango, CO?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a personalized quote based on your timeline." },
    { q: "Where can I get passport photos in Durango?", a: "City Market (3130 Main Ave and 508 E 8th Ave) and Walgreens (2701 Main Ave) all offer passport photo services. UPS Store at 270 E 8th Ave also provides photos. Must be 2×2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve the Southern Ute Indian Tribe?", a: "Yes. Fast Passport Center serves all residents of La Plata County including Southern Ute tribal members. Contact us for guidance on any specific documentation needs. We respect tribal sovereignty and can work with tribal ID documents where applicable." },
    { q: "Is there passport service closer than Denver — like in Albuquerque or Salt Lake City?", a: "Colorado is served by the Colorado Passport Agency. While Albuquerque and Salt Lake City are geographically closer to Durango, they serve New Mexico and Utah residents respectively. Our courier service makes the Denver agency accessible from anywhere in Colorado without the drive." },
  ],
  photoLocations: [
    { name: "City Market — South Durango", address: "3130 Main Ave, Durango, CO 81301", hours: "Mon–Sun: 6AM–11PM", website: "https://www.citymarket.com/" },
    { name: "City Market — North Durango", address: "508 E 8th Ave, Durango, CO 81301", hours: "Mon–Sun: 6AM–11PM", website: "https://www.citymarket.com/" },
    { name: "Walgreens — Main Avenue", address: "2701 Main Ave, Durango, CO 81301", hours: "Mon–Sun: 8AM–10PM", website: "https://www.walgreens.com/storelocator" },
    { name: "UPS Store — Durango", address: "270 E 8th Ave, Durango, CO 81301", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM", website: "https://www.theupsstore.com/" },
    { name: "Walmart — Durango", address: "1155 S Camino Del Rio, Durango, CO 81303", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store-finder" },
    { name: "FedEx Office Ship Center — Farmington", address: "3030 E Main St, Farmington, NM 87402", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–2PM", website: "https://www.office.fedex.com/" },
  ],
  dmvLocations: [
    { name: "DMV — Durango (La Plata County)", address: "98 Everett St, Suite A, Durango, CO 81303", hours: "Mon–Fri: 8AM–5PM", note: "Full-service La Plata County DMV. REAL ID and driver's license renewals. Appointment strongly recommended. Located in Bodo Park.", featured: true },
    { name: "DMV — Cortez (Montezuma County)", address: "109 W Main St, Cortez, CO 81321", hours: "Mon–Fri: 8AM–5PM", note: "Alternative DMV serving Montezuma County and western La Plata County residents. REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "DRO",
      name: "Durango-La Plata County Airport",
      distance: "12 miles southeast of downtown Durango",
      address: "1000 Airport Rd, Durango, CO 81303",
      note: "Primary airport serving Durango and the Four Corners region. Daily flights to DEN, DFW, and seasonal flights to PHX. All international travel requires connection through a major hub.",
      flightUrl: "https://www.durangogov.org/airport",
      flightLabel: "DRO Flight Info",
      featured: true,
    },
    {
      code: "FMN",
      name: "Four Corners Regional Airport — Farmington, NM",
      distance: "60 miles south of Durango via US-550",
      address: "1000 W Navajo St, Farmington, NM 87401",
      note: "Regional alternative airport serving the Four Corners. Limited flights — primarily to Denver (DEN) and Phoenix (PHX).",
      flightUrl: "https://www.fmtn.org/airport",
      flightLabel: "FMN Flight Info",
      featured: false,
    },
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "370 miles northeast of Durango via US-285",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "Colorado's primary international airport. Nonstop flights to Europe, Asia, Mexico, Canada. 6.5-hour drive or 1-hour connecting flight from DRO.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: false,
    },
  ],
};